<div class="modal-header full-preview-modal-header">
  <button data-automation="full-preview-close-button" type="button" class="btn-close" (click)="onCloseClick()"></button>
</div>

<div class="modal-body full-preview-modal-body">
  <div class="full-preview-container" [style]="modalProperties.previewBackgroundStyles">
    <div class="login-container-inner">
      <div class="login-container-form border-rad-all-2">
        <div>
          <img
            class="company-logo-image"
            [src]="modalProperties.previewLogo"
            alt="Company Logo"
            data-automation="full-preview-logo"
          />
        </div>
        <div class="top-buffer mb-0">
          <button class="btn btn-border btn-primary btn-lg w-100" type="button" data-automation="full-preview-button">
            <i [ngClass]="ziroIcons.LOCK" class="me-2"></i>
            {{ modalProperties.loginButtonLabel }}
          </button>
        </div>
      </div>
    </div>
    <footer class="bg-light footer py-2 text-center flex-column">
      <div class="navbar-text">
        <div [innerHtml]="companyFooterLabel | escapeHtml: { year }" data-automation="full-preview-footer-year"></div>
        @if (modalProperties.showSupportLink) {
          <a
            href="#"
            (click)="$event.preventDefault()"
            id="full-preview-support-link"
            data-automation="full-preview-support-link"
          >
            {{ 'tkey;footer.support' | translate }}
          </a>
        }
      </div>
    </footer>
  </div>
</div>

<div class="modal-footer full-preview-modal-footer"></div>
